"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Tabs/index.tsx
var Tabs_exports = {};
__export(Tabs_exports, {
  Tab: () => Tab,
  TabTheme: () => TabTheme,
  Tabs: () => Tabs
});
module.exports = __toCommonJS(Tabs_exports);
var import_classnames = __toESM(require("classnames"));
var import_react2 = __toESM(require("react"));

// src/components/Tabs/Tab.tsx
var import_react = __toESM(require("react"));
function Tab(props) {
  return /* @__PURE__ */ import_react.default.createElement("div", null);
}

// src/components/Tabs/index.tsx
var defaultUlClassName = ["v2-list-none v2-p-0", "v2-flex v2-flex-wrap"].join(
  " "
);
var defaultLiClassName = ["v2-flex-initial", "v2-rounded-t"].join(" ");
var defaultLiButtonClassName = [
  "v2-text-neutral-900 v2-font-circular v2-rounded-t",
  "v2-text-base v2-font-semibold v2-text-neutral-900",
  "v2-items-center v2-justify-center v2-py-2.5 v2-px-5",
  "disabled:v2-opacity-50"
].join(" ");
var TabTheme = /* @__PURE__ */ ((TabTheme2) => {
  TabTheme2["Default"] = "default";
  TabTheme2["Blue"] = "blue";
  return TabTheme2;
})(TabTheme || {});
var themes = {
  ["default" /* Default */]: {
    ulClassName: "v2-border-solid v2-border-0 v2-border-neutral-200 v2-mb-0",
    liButtonClassName: "hover:v2-bg-yellow-50 v2-bg-transparent v2-border-0",
    activeLiClassName: "v2-bg-yellow-50"
  },
  ["blue" /* Blue */]: {
    ulClassName: "v2-gap-x-0.5 v2-border-none",
    liClassName: "flex-1 w-full",
    liButtonClassName: (0, import_classnames.default)(
      "v2-border-0 v2-border-b-[5px] v2-border-solid v2-border-neutral-200",
      "v2-transform v2-transition-all hover:v2-border-blue-500 v2-duration-300",
      "v2-bg-transparent w-full"
    ),
    activeLiButtonClassName: "v2-border-blue-500"
  }
};
function Tabs({
  id,
  active = 0,
  className,
  children,
  toolbar,
  setActive,
  tabHeaderClassName,
  tabContentClassName,
  tabPanelClassName,
  ulClassName,
  liClassName,
  activeLiClassName = "",
  liButtonClassName,
  activeLiButtonClassName = "",
  hideBottomBorder = false,
  theme = "default" /* Default */
}) {
  const themeClasses = themes[theme];
  const {
    activeLiClassName: themeActiveLiClassName = "",
    activeLiButtonClassName: themeActiveLiButtonClassName = ""
  } = themeClasses;
  const handleTabClick = (index) => {
    setActive == null ? void 0 : setActive(index);
  };
  const tabParts = (0, import_react2.useMemo)(() => {
    const tabList = [];
    const tabPanel = [];
    children == null ? void 0 : children.forEach((child, index) => {
      var _a;
      if (!child || !(((_a = child == null ? void 0 : child.type) == null ? void 0 : _a.name) == Tab.name)) {
        return;
      }
      const activeTab = index == active;
      const { disabled, children: children2, onClick } = child.props;
      const onTabClick = () => {
        onClick == null ? void 0 : onClick();
        handleTabClick(index);
      };
      tabList.push(
        /* @__PURE__ */ import_react2.default.createElement(
          "li",
          {
            id: child.props.id,
            role: "presentation",
            key: index,
            className: (0, import_classnames.default)(
              "tab-list-item",
              liClassName,
              themeClasses == null ? void 0 : themeClasses.liClassName,
              defaultLiClassName,
              {
                active: activeTab,
                [`${activeLiClassName}`]: activeTab,
                [`${themeActiveLiClassName}`]: activeTab
              }
            ),
            onClick: onTabClick
          },
          /* @__PURE__ */ import_react2.default.createElement(
            "button",
            {
              role: "tab",
              className: (0, import_classnames.default)(
                "tab-list-button",
                liButtonClassName,
                defaultLiButtonClassName,
                themeClasses == null ? void 0 : themeClasses.liButtonClassName,
                {
                  [`${activeLiButtonClassName}`]: activeTab,
                  [`${themeActiveLiButtonClassName}`]: activeTab
                }
              ),
              disabled
            },
            child.props.title
          )
        )
      );
      tabPanel.push(
        /* @__PURE__ */ import_react2.default.createElement(
          "div",
          {
            role: "tabpanel",
            key: index,
            className: (0, import_classnames.default)(
              "tab-panel",
              tabPanelClassName,
              themeClasses == null ? void 0 : themeClasses.tabPanelClassName,
              "v2-absolute v2-p-2 v2-w-full v2-transition-opacity",
              {
                "v2-hidden v2-z-0": !activeTab,
                "v2-z-10": activeTab
              }
            )
          },
          children2
        )
      );
    });
    return {
      tabList,
      tabPanel
    };
  }, [active]);
  return /* @__PURE__ */ import_react2.default.createElement("div", { id, className }, /* @__PURE__ */ import_react2.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(
        "tab-header v2-mb-2",
        tabHeaderClassName,
        themeClasses == null ? void 0 : themeClasses.tabHeaderClassName
      )
    },
    /* @__PURE__ */ import_react2.default.createElement(
      "ul",
      {
        role: "tablist",
        className: (0, import_classnames.default)(
          "tab-list",
          ulClassName,
          themeClasses == null ? void 0 : themeClasses.ulClassName,
          defaultUlClassName,
          {
            "v2-border-b-2": !hideBottomBorder
          }
        )
      },
      tabParts.tabList
    ),
    toolbar && /* @__PURE__ */ import_react2.default.createElement("div", { className: "tab-toolbar v2-w-full" }, toolbar)
  ), /* @__PURE__ */ import_react2.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(
        "tab-content v2-relative",
        tabContentClassName,
        themeClasses == null ? void 0 : themeClasses.tabContentClassName
      )
    },
    tabParts.tabPanel
  ), children);
}
